import http from '@/communication/AuthConnection'

export default async ({ commit }, {
  pativo,
  factor = 1,
  lab = null,
  startDate = null,
  endDate = null,
  onlyAssociated = null,
  result = null,
  guaranted = null,
  updateRankingDate = null,
  winnerDistributor = null,
  secondDistributor = null,
  thirdDistributor = null }) => {
  try {
    const { data } = await http.post(`/v1/stock/item-history/download-csv`, {
      pativo,
      factor,
      lab,
      onlyAssociated,
      result,
      guaranted,
      startDate,
      endDate,
      updateRankingDate,
      winnerDistributor,
      secondDistributor,
      thirdDistributor
    },
    { responseType: 'blob' })

    if (data) {
      return data
    } else {
      return Promise.reject(Error('Não foi possível carregar a listagem'))
    }
  } catch (error) {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/item-history/download-csv.js